module.exports = __webpack_public_path__ + "static/media/check.630c405a.svg";